<template>
  <div class="CampaignDashboard">
    <el-card class="box-card">
      <div>
        <p class="text-xl font-bold">Campaigns</p>
        <div class="flex">
          <div class="input-box box-300">
            <div class="filter">
              <p class="input-label">Location</p>
              <base-locations-dropdown class="mdms" @update="dropDownUpdate" />
            </div>
          </div>

          <div class="input-box box-220">
            <div class="filter">
              <p class="input-label">From</p>
              <el-date-picker
                v-model="fromDate"
                format="dd-MM-yyyy"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="Select Date"
                :picker-options="{
									firstDayOfWeek: 1
								}"
                @change="fromDateChange"
              />
            </div>
          </div>

          <div class="input-box box-220">
            <div class="filter">
              <p class="input-label">To</p>
              <el-date-picker
                v-model="toDate"
                format="dd-MM-yyyy"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="Select Date"
                :picker-options="{
									disabledDate: date => {
										return date < fromDate;
									},
									firstDayOfWeek: 1
								}"
                @change="toDateChange"
              />
            </div>
          </div>

          <div>
            <div class="filter">
              <label>&nbsp;</label>
              <BaseButton
                type="submit"
                style="height: 40px; margin: 0 auto;"
                class="action-btn orng-btn"
                buttonclass="btn p-2 text-xs"
                @click="() => $router.push({ name: 'CreateCampaign' }).catch(()=>{})"
              >Create Campaign</BaseButton>
            </div>
          </div>
        </div>
      </div>
    </el-card>

    <el-card class="box-card mt-2" v-loading="isCampaignsListLoading">
      <div class="campaignTable">
        <table>
          <thead>
            <th>CAMPAIGN</th>
            <th>CHANNEL</th>
            <th>COMMUNICATION</th>
            <th>DATE</th>
            <th>STATUS</th>
            <th></th>
          </thead>
          <tbody>
            <tr v-for="(item,index) in campagins_list" :key="index">
              <td>
                <div class="campaign-heading">{{ item.name }}</div>
                <small>{{item.promotion_type}}</small>
              </td>
              <td>Dine in Delivery</td>
              <td class="uppercase">{{ item.communication_types.length ? (item.communication_types).toString() : '-' }}</td>
              <td>{{ new Date(item.start_date).toLocaleDateString() }} to {{ new Date(item.end_date).toLocaleDateString() }}</td>
              <td>
                <div class="status-badge">Active</div>
              </td>
              <td>
                <!-- <img src="../../../../assets/images/edit.png" class="cursor-pointer mr-2" width="22" alt=""> -->
                <img src="../../../../assets/images/delete-icon.png" class="cursor-pointer" width="22" alt="" @click="deleteCampaignsNetWorkCallBack(index)">
              </td>
            </tr>
          </tbody>
        </table>

        <div class="pagination pt-0 text-right" v-if="campagins_list.length">
          <!-- <el-pagination
            background
            :current-page.sync="pageInfo.currentPage"
            :page-sizes="[5, 10, 15]"
            :page-size.sync="pageInfo.pageSize"
            layout="sizes, prev, pager, next"
            :total="tablePageCount"
            @size-change="handlePageInfoChange"
            @current-change="handlePageInfoChange"
          /> -->
          <el-pagination
            background
            layout="prev, pager, next"
            :total="20"
          />
        </div>

        <div v-if="!campagins_list.length" style="text-align: center; font-size: 14px; font-weight: 600; color: #e29d5a; padding: 15px;">
          No data available
        </div>
      </div>
    </el-card>

  </div>
</template>

<script>
import BaseLocationsDropdown from '../../../baseLocationsDD/BaseLocationsDD.vue';
import CampaignService from '../../../../services/campaignsService.js';
import moment from "moment";
export default {
  name: "CampaignDashboard",
  components: {
    BaseLocationsDropdown
  },
  data: () => {
    return {
      fromDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      toDate: new Date(new Date().getFullYear(), 11, 31),
      location: "",
      campagins_list: [],
      isCampaignsListLoading: false,
      selectedOutlet: []
    };
  },
  created() {
    // this.getPromotions();
    this.getAllCampaignsNetWorkCallBack();
  },
  methods: {
    dropDownUpdate(arg) {
      console.log("arg", arg);
      if (arg.basics == "outlet") {
				this.selectedOutlet = arg.selected.map(e => {
					return e.id;
        });
         this.getAllCampaignsNetWorkCallBack();
			} else {
        this.selectedOutlet = []
      }
    },
    fromDateChange(event) {
      this.getAllCampaignsNetWorkCallBack();
    },
    toDateChange(event) {
      this.getAllCampaignsNetWorkCallBack();
    },
    // getPromotions() {
    //   CampaignService.getPromotions().then(res => {
    //     console.log(res);
    //   })
    // },
    getAllCampaignsNetWorkCallBack(){
      this.isCampaignsListLoading = true;   //enabled loader
      let params = {};
      // params.outlets = ['9b3819cb-c5bb-453a-ae20-e27735faa026'];
      params.outlets = this.selectedOutlet;
      params.from_date = moment(this.fromDate).format('YYYY-MM-DD');
      params.to_date = moment(this.toDate).format('YYYY-MM-DD');

      CampaignService.getAllCampaigns(params)
      .then(res =>{
        if(res.status == 200){
          this.campagins_list = JSON.parse(res.data);
          this.isCampaignsListLoading = false;   //disabled loader
        }else{
          this.campagins_list = [];
          this.isCampaignsListLoading = false;   //disabled loader
        }
        // console.log('getAllCampaignsNetWorkCallBack', this.campagins_list);
      })
      .catch(function(err){
        console.log(err);
        this.isCampaignsListLoading = false;   //disabled loader
        this.campagins_list = [];
      }.bind(this))
    },
    deleteCampaignsNetWorkCallBack(index){
      this.isCampaignsListLoading = true;   //enabled loader
      let params = {};
      params.id = this.campagins_list[index].id;
      console.log(this.campagins_list[index]);

      CampaignService.deleteCampaign(params)
      .then(res =>{
        if(res.status == 200){
          this.isCampaignsListLoading = false;   //disabled loader

          this.campagins_list.splice(index, 1);     //remove campagin from list after api success

          this.$notify.success({
            title: "Success",
            message: 'Campaign deleted successfully!'
          });
        }else{
          this.isCampaignsListLoading = false;   //disabled loader
          this.$notify.error({
            title: "Error",
            message: 'Something went wrong'
          });
        }
      })
      .catch(function(err){
        console.log(err);
        this.isCampaignsListLoading = false;   //disabled loader
      }.bind(this))
    }
  }
};
</script>

<style lang="scss" scoped>
@import url("./CampaignDashboard.scss");
</style>
<style>
.el-card {
  overflow: unset!important;
}
</style>
